import { format, parseISO } from 'date-fns';

//@TODO: move to gloabl util
export function getFormattedDuration(value: string | number) {
  const byUnit = false;

  if (byUnit) {
    let formattedValue = value;
    let units = 's';

    if (typeof value === 'number' && !isNaN(value)) {
      if (value >= 3600) {
        formattedValue = value / 3600;
        units = 'h';
      } else if (value >= 60) {
        formattedValue = value / 60;
        units = 'm';
      }

      return (
        formattedValue.toLocaleString('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 1,
        }) + units
      );
    }
  } else {
    const totalSeconds = +value;
    if (isNaN(totalSeconds)) return '0s';

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    // Subtract hours and minutes to get leftover seconds, then round them
    const seconds = Math.round(totalSeconds - (hours * 3600 + minutes * 60));

    // Normalize overflow (e.g., 60s -> 1m)
    let adjustedMinutes = minutes;
    let adjustedHours = hours;
    let adjustedSeconds = seconds;

    if (seconds === 60) {
      adjustedSeconds = 0;
      adjustedMinutes += 1;
    }

    if (adjustedMinutes === 60) {
      adjustedMinutes = 0;
      adjustedHours += 1;
    }

    const parts = [];
    if (adjustedHours > 0) parts.push(`${adjustedHours}h`);
    if (adjustedMinutes > 0) parts.push(`${adjustedMinutes}m`);
    if (adjustedSeconds > 0 || parts.length === 0) parts.push(`${adjustedSeconds}s`);

    return parts.join(' ');
  }
}

export function formatSecondsToHHMMSS(totalSeconds: number) {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.round(totalSeconds % 60);

  const pad = (num: number) => String(num).padStart(2, '0');

  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

export const getFormattedDate = (date: any) => {
  const parsedDate = parseISO(date);
  const formattedDate = format(parsedDate, 'dd.MM.yyyy');
  return { date, formattedDate };
};
